module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dialogTitle":"Setup help","subjectTitle":"Subject","subjectInputLabel":"Subject","commentTitle":"Describe the issue","commentInputLabel":"Describe how the issue occurred","contactsTitle":"Your contacts","contactsNameLabel":"Name","contactsEmailLabel":"E-mail","contactsPhoneLabel":"Phone number","send":"Send"}}')
  delete Component.options._Ctor
}
